import React, { useRef } from 'react';
import AngelHeroSection from '../../../components/landingPage/AngelNetworksPage/AngelHeroSection';
import AngelStatBand from '../../../components/landingPage/AngelNetworksPage/AngelStatBand';
import AngelProblemSection from '../../../components/landingPage/AngelNetworksPage/AngelProblemSection';
import AngelFlowsSection from '../../../components/landingPage/AngelNetworksPage/AngelFlowsSection';
import AngelChangesSection from '../../../components/landingPage/AngelNetworksPage/AngelChangesSection';
import AngelQuotesSection from '../../../components/landingPage/AngelNetworksPage/AngelQuotesSection';
import AngelPricingSection from '../../../components/landingPage/AngelNetworksPage/AngelPricingSection';
import AngelCtaSection from '../../../components/landingPage/AngelNetworksPage/AngelCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import useDocumentHead from '../../../components/landingPage/AeoArticles/useDocumentHead';
import hubWebPageSchema from '../../../components/landingPage/AeoArticles/aeoHubSchema';
import { AEO_HUBS } from '../../../components/landingPage/AeoArticles/aeoArticlesData';

const AngelsNetworks = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);
    useDocumentHead({ canonicalPath: `${AEO_HUBS['angel-network']['hubPath']}/`, schema: hubWebPageSchema('angel-network') });

    return (
        <div className="lp-page" ref={rootRef}>
            <AngelHeroSection />
            <AngelStatBand />
            <AngelProblemSection />
            <AngelFlowsSection />
            <AngelChangesSection />
            <AngelQuotesSection />
            <AngelPricingSection />
            <AngelCtaSection />
            <AeoResourcesSection icpSlug="angel-network" />
        </div>
    );
};

export default AngelsNetworks;
